<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <ZoneTabs
        :zone="zone"
        v-model="currentTab"
        @delete="deleteZone"
        @edit="editZone"
      />
      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="zone">
          <ZoneDetails :zone="zone"/>
        </v-tab-item>
        <v-tab-item value="postal_code">
          <ZonePostalCodeDetails :zone="zone"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { zonesService } from '../../utils/services/zones.service';
  import ZoneTabs from '../../components/app/Zones/ZoneTabs';
  import ZoneDetails from '../../components/app/Zones/ZoneDetails';
  import ZonePostalCodeDetails from '../../components/app/Zones/ZonePostalCodeDetails';
  import ZoneModal from '../../components/modals/Zones/ZoneModal';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'AdoptionShow',
    components: {
        Loader,
        ZoneTabs,
        ZoneDetails,
        ZonePostalCodeDetails,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        currentTab: this.tab,
        zone: {},
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchZone(id) {
        return zonesService.get(id)
        .then(response => {
          this.zone = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },
      async deleteZone() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return zonesService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.ZONE}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editZone() {
          this.showModal({
              component: ZoneModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('ZONE'),
                onSave: (
                  form,
                  error,
                ) => zonesService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchZone(this.id);
      this.loading = false;
    },
  };
</script>
